apiGetNodes